/**
 * Component Registry for Iron Ridge and Stonegate Apartments
 *
 * Inherits from @vibesites-aion-management/theme-belmont with dual-portal ResidentAccess.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-aion-management/theme-belmont/registry';
import { ResidentAccess } from './components/ResidentAccess';

const propertyOverrides: Partial<ComponentRegistry> = {
  ResidentAccess,
};

export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
